import { yhcAreaCodesInDisplayOrder, yhcAreasByCode } from '../../constants/area'
import { fetchVersionBasedOnDatetime } from '../YhcEstimateFormFrontPage/YhcEstimateFormFrontService'

export type SelectOptionItem = { label: string; value: string }

/**
 * yhcAreasByCode の sort 昇順で都道府県選択肢を生成する。
 * Object.keys は '10' 等を整数キーとして数値ソートするため使わない。
 */
export const buildYhcAreaCodeSelections = (): SelectOptionItem[] => {
  return yhcAreaCodesInDisplayOrder.map((code) => ({
    label: yhcAreasByCode[code].name,
    value: code,
  }))
}

export const formatPrefCodeLabel = (prefCode: string | null | undefined): string => {
  if (!prefCode) return ''
  if (prefCode in yhcAreasByCode) {
    return yhcAreasByCode[prefCode as keyof typeof yhcAreasByCode].name
  }
  return prefCode
}

/**
 * 最新の郵便番号マスタバージョンを取得する
 */
export const fetchLatestZipMasterVersion = async (): Promise<string | null> => {
  const now = $core.$dayjs().format('YYYY-MM-DD HH:mm:ss')
  const version = await fetchVersionBasedOnDatetime(now)
  return version || null
}

/** prefCode + version ごとの市区郡選択肢キャッシュ（管理画面の再取得レース緩和用） */
const citySelectionsCache = new Map<string, SelectOptionItem[]>()

/**
 * 指定 prefCode について、最新郵便番号マスタから市区郡の選択肢を取得する
 */
export const fetchCitySelectionsForPrefCode = async (
  prefCode: string,
): Promise<SelectOptionItem[]> => {
  if (!prefCode) return []

  const version = await fetchLatestZipMasterVersion()
  if (!version) return []

  const cacheKey = `${prefCode}::${version}`
  const cached = citySelectionsCache.get(cacheKey)
  if (cached) {
    return cached
  }

  const records = await $core.$models.yhc_by_zipcodes.find({
    filter: {
      version: { _eq: version },
      prefCode: { _eq: prefCode },
    },
    fields: ['city'],
    limit: -1,
  })

  const cities = new Set<string>()
  for (const record of records || []) {
    const city = typeof record?.city === 'string' ? record.city.trim() : ''
    if (city) {
      cities.add(city)
    }
  }

  const options = Array.from(cities)
    .sort((a, b) => a.localeCompare(b, 'ja'))
    .map((city) => ({ label: city, value: city }))

  citySelectionsCache.set(cacheKey, options)
  return options
}
